import React from 'react'
import HeaderImage from 'images/inline/modal/enter-to-win.svg'
import './BreakGateModals.scss'

const BreakConversionModal = ({
  closeModal,
  onSignUpClick,
  onHowItWorksClick,
}) => {
  return (
    <div className={`modal-container-top modal-break-conversion`}>
      <button
        className="modal-close"
        onClick={closeModal}
        aria-label="Next"
      ></button>
      <div className={`modal-image-header`}>
        <HeaderImage className={`header-image`} />
      </div>
      <div className={`modal-content-zone`}>
        <h1>Like what you&apos;re seeing?</h1>
        <p>
          Sign up with Dailybreak to get more of the good stuff&mdash;games,
          trivia, points towards entering to win cool prizes. Did we mention
          it&apos;s free?
        </p>
        <a onClick={onSignUpClick} className="btn signup">
          Sign up
        </a>
        <a
          onClick={onHowItWorksClick}
          className={`modal-bottom-link`}
          to="/how-it-works"
        >
          How it works
        </a>
      </div>
    </div>
  )
}

export default BreakConversionModal
